(() => {
  'use strict';
  if (window.FemiekoNordic) { window.FemiekoNordic.init(); return; }
  let destroyCurrent = () => {};
  function init() {
    destroyCurrent();
    const roots = [...document.querySelectorAll('.femieko-nordic')];
    const $ = id => document.getElementById('nordic-' + id);
    const $$ = selector => roots.flatMap(root => [...root.querySelectorAll(selector)]);
    const dataNode = $('ritualData');
    if (!roots.length || !dataNode) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    const { locale: L, products: P } = data;
    const lifecycle = new AbortController(), signal = lifecycle.signal, cleanups = [];
    const on = (el, name, fn, options = {}) => el?.addEventListener(name, fn, { ...options, signal });
    const money = cents => new Intl.NumberFormat(L.lang || 'da', { style: 'currency', currency: data.currency }).format(cents / 100);
    roots.forEach(root => root.classList.add('nordic-enhanced'));
    $$('.reveal').forEach(el => el.classList.add('revealed'));
    let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0, scrollFrame = 0, resizeFrame = 0;
    const observers = [];
    let animate = () => {};
    function syncMotion() {
      const stop = paused || document.hidden;
      roots.forEach(root => { root.classList.toggle('motion-paused', stop); root.classList.toggle('motion-enabled', !stop); });
      const button = $('motionToggle');
      if (button) { button.setAttribute('aria-pressed', String(paused)); button.querySelector('span').textContent = paused ? L.motionOff : L.motion; }
      cancelAnimationFrame(frame); frame = 0;
      if (!stop) frame = requestAnimationFrame(animate);
    }
    on($('motionToggle'), 'click', () => { paused = !paused; syncMotion(); });
    on(media, 'change', e => { paused = e.matches; syncMotion(); });
    on(document, 'visibilitychange', syncMotion);
    const hero = roots.flatMap(r => [...r.querySelectorAll('.hero-photo')])[0];
    const animatedSurfaces = $$('.hero-photo,.story-stage');
    const surfaceObserver = new IntersectionObserver(entries => entries.forEach(e => {
      e.target.dataset.cinematicVisible = String(e.isIntersecting);
      e.target.classList.toggle('nordic-in-view', e.isIntersecting);
    }), { threshold: .05 });
    animatedSurfaces.forEach(el => surfaceObserver.observe(el)); observers.push(surfaceObserver);

    // Three scenes: native tabs, keyboard navigation, touch and desktop scroll progression.
    const stage = $('storyStage'), story = $('storyScroll'), tabs = $$('[data-slide]');
    let currentSlide = 0, manualBoundary = null, pointer = null;
    const offset = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 100;
    function automaticIndex() {
      if (!story || !stage) return 0;
      const rect = story.getBoundingClientRect(), distance = rect.height - stage.offsetHeight;
      return distance <= 1 ? 0 : Math.min(2, Math.max(0, Math.floor((offset() - rect.top) / distance * 3)));
    }
    function setSlide(index, user = false, focus = false) {
      if (!stage || !Number.isInteger(index) || index < 0 || index > 2) return;
      if (user) manualBoundary = automaticIndex();
      currentSlide = index;
      tabs.forEach((b, i) => {
        b.classList.toggle('active', i === index); b.setAttribute('aria-selected', String(i === index)); b.tabIndex = i === index ? 0 : -1;
        const scene = $('scene' + i);
        if (scene) { scene.classList.toggle('active', i === index); scene.setAttribute('aria-hidden', String(i !== index)); scene.inert = i !== index; }
      });
      if ($('sceneCount')) $('sceneCount').textContent = `0${index + 1} / 03`;
      if (user && $('sceneStatus')) $('sceneStatus').textContent = L.sceneTabs[index];
      if (focus) tabs[index]?.focus({ preventScroll: true });
    }
    tabs.forEach((b, i) => {
      on(b, 'click', () => setSlide(i, true));
      on(b, 'keydown', e => { const next = { ArrowRight: (i + 1) % 3, ArrowLeft: (i + 2) % 3, Home: 0, End: 2 }[e.key]; if (next !== undefined) { e.preventDefault(); setSlide(next, true, true); } });
    });
    on($('prevScene'), 'click', () => setSlide((currentSlide + 2) % 3, true));
    on($('nextScene'), 'click', () => setSlide((currentSlide + 1) % 3, true));
    if (stage) {
      stage.style.touchAction = 'pan-y';
      on(stage, 'pointerdown', e => { if (e.pointerType === 'touch' && !pointer) pointer = { id: e.pointerId, x: e.clientX, y: e.clientY }; });
      on(stage, 'pointerup', e => {
        if (!pointer || pointer.id !== e.pointerId) return;
        const dx = e.clientX - pointer.x, dy = e.clientY - pointer.y; pointer = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) setSlide((currentSlide + (dx < 0 ? 1 : 2)) % 3, true);
      });
      on(stage, 'pointercancel', () => { pointer = null; }); on(stage, 'lostpointercapture', () => { pointer = null; }); on(window, 'blur', () => { pointer = null; });
      const frost = stage.querySelector('.frost');
      on(stage, 'pointermove', e => { if (!frost || currentSlide || paused || e.pointerType === 'touch') return; const r = stage.getBoundingClientRect(); frost.style.setProperty('--frost-x', ((e.clientX - r.left) / r.width * 100) + '%'); frost.style.setProperty('--frost-y', ((e.clientY - r.top) / r.height * 100) + '%'); });
      on(stage, 'pointerleave', () => { frost?.style.removeProperty('--frost-x'); frost?.style.removeProperty('--frost-y'); pointer = null; });
      setSlide(0);
    }
    function updateScroll() {
      scrollFrame = 0;
      if (story && stage && innerWidth > 800 && !paused) {
        const r = story.getBoundingClientRect(), auto = automaticIndex();
        if (r.top < offset() + 100 && r.bottom > stage.offsetHeight) {
          if (manualBoundary !== null && auto !== manualBoundary) manualBoundary = null;
          if (manualBoundary === null && auto !== currentSlide) setSlide(auto);
        }
      }
      const kit = $('kit'), sticky = $('ritualSticky');
      if (kit && sticky && hero) { const k = kit.getBoundingClientRect(); sticky.classList.toggle('visible', hero.getBoundingClientRect().bottom < 100 && !(k.top < innerHeight * .55 && k.bottom > innerHeight * .25)); }
    }
    on(window, 'scroll', () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScroll); }, { passive: true });
    on(window, 'resize', updateScroll); updateScroll();

    let selectedProblem = 0;
    function showProblem(index) {
      const problem = L.problems[index]; if (!problem || !$('answerPanel')) return;
      selectedProblem = index;
      $$('[data-problem]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.problem) === index)));
      $('answerTitle').textContent = problem.title; $('answerBody').textContent = problem.body;
      $('answerProducts').replaceChildren();
      problem.picks.forEach((key, i) => {
        const p = P[key]; if (!p || !p.variants.length) return;
        const a = document.createElement('a'), img = document.createElement('img'), div = document.createElement('div'), b = document.createElement('b'), small = document.createElement('span');
        a.className = 'mini-product'; a.href = p.url; img.src = p.image; img.alt = 'Femieko ' + p.name; img.loading = 'lazy'; img.width = 100; img.height = 105;
        b.textContent = p.name; small.textContent = problem.why[i]; div.append(b, small); a.append(img, div); $('answerProducts').append(a);
      });
      $$('[data-product]').forEach(row => row.classList.toggle('highlight', problem.picks.includes(row.dataset.product)));
      $('answerStatus').textContent = problem.chip;
    }
    $$('[data-problem]').forEach(b => on(b, 'click', () => showProblem(Number(b.dataset.problem))));
    $$('[data-setting]').forEach(a => on(a, 'click', () => showProblem(Number(a.dataset.setting))));
    function filterFlow(flow) {
      const keys = { swim: ['kaia', 'scarlett', 'thea', 'maja'], internal: ['disc', 'cup', 'tampon'], dry: ['margaret', 'flexi', 'dry'] }[flow]; if (!keys) return;
      $$('[data-flow]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.flow === flow)));
      $$('[data-product]').forEach(row => { row.hidden = !keys.includes(row.dataset.product); });
    }
    $$('[data-flow]').forEach(b => on(b, 'click', () => filterFlow(b.dataset.flow)));
    showProblem(0); filterFlow('swim');

    const form = $('kitForm');
    let previous = {}, submitting = false, ambiguous = false, completed = false;
    function populate(key, select, preserve = false) {
      if (!select) return;
      const old = preserve ? select.selectedOptions[0]?.dataset.size : '';
      const hint = new Option(['disc', 'cup'].includes(key) ? L.chooseModel : L.chooseSize, ''); select.replaceChildren(hint);
      (P[key]?.variants || []).forEach(v => {
        const label = v.model ? v.name + (v.size === 'Default Title' ? '' : ' · ' + v.size) : v.size;
        const option = new Option(label + ' · ' + money(v.price) + (v.available ? '' : ' · ' + L.soldOut), String(v.id));
        option.disabled = !v.available; option.dataset.size = v.size; if (old && v.size === old && v.available) option.selected = true; select.append(option);
      });
    }
    function selection() {
      const result = { ids: [], chosen: [], errors: [], total: 0 };
      if (!form) return result;
      const choices = [form.elements.swim.value, form.elements.internal.value, form.elements.after.value];
      choices.forEach((key, i) => {
        if (key === 'none') return;
        result.ids.push(key); const p = P[key];
        const id = i === 0 ? $('swimSize').value : i === 2 ? $('drySize').value : ['disc', 'cup'].includes(key) ? $('internalModel').value : p?.variants.find(v => v.available)?.id;
        const v = p?.variants.find(v => String(v.id) === String(id) && v.available);
        if (!v) result.errors.push(key); else result.chosen.push({ ...v, product: key, quantity: 1 });
        result.total += v ? v.price : p?.price || 0;
      });
      if (!result.ids.length) result.errors.push('empty');
      return result;
    }
    function updateKit() {
      if (!form) return;
      const choices = { swim: form.elements.swim.value, internal: form.elements.internal.value, after: form.elements.after.value };
      if (choices.swim !== previous.swim) {
        if (choices.swim !== 'none') populate(choices.swim, $('swimSize'), true);
        const img = $('builderMainImage'); if (img) { img.removeAttribute('srcset'); img.src = choices.swim === 'none' ? data.poolImage : P[choices.swim].worn; img.alt = choices.swim === 'none' ? L.sceneAlt[2] : 'Femieko ' + P[choices.swim].name; }
      }
      if (choices.after !== previous.after && choices.after !== 'none') populate(choices.after, $('drySize'), true);
      if (choices.internal !== previous.internal && ['disc', 'cup'].includes(choices.internal)) populate(choices.internal, $('internalModel'));
      previous = choices;
      for (const [field, row, control] of [['swim', 'swimSizeRow', 'swimSize'], ['after', 'drySizeRow', 'drySize'], ['internal', 'internalModelRow', 'internalModel']]) {
        const active = field === 'internal' ? ['disc', 'cup'].includes(choices[field]) : choices[field] !== 'none';
        $(row).hidden = !active; $(control).required = active; $(control).disabled = !active;
      }
      const current = selection(), count = current.ids.length;
      $('kitTotal').textContent = money(current.total); $('selectionCount').textContent = count + ' ' + (count === 1 ? L.item : L.items);
      if ($('stickySummary')) $('stickySummary').textContent = money(current.total) + ' · ' + count + ' ' + (count === 1 ? L.item : L.items);
      $('checkoutLink').setAttribute('aria-disabled', String(!!current.errors.length));
      if (!submitting && !ambiguous && !completed) $('kitMessage').textContent = current.errors.length ? L.emptySelection : '';
      const internal = current.chosen.find(v => v.product === choices.internal); $('internalSelected').textContent = internal ? internal.name + ' · ' + money(internal.price) : '';
      $('galleryProducts').replaceChildren();
      current.ids.forEach(key => { const img = document.createElement('img'), v = current.chosen.find(v => v.product === key); img.src = v?.model && v.image ? v.image : P[key].image; img.alt = 'Femieko ' + (v?.model ? v.name : P[key].name); img.loading = 'lazy'; img.width = 90; img.height = 100; $('galleryProducts').append(img); });
    }
    if (form) {
      form.querySelectorAll('input[data-availability]').forEach(input => { input.disabled = !P[input.value]?.variants.some(v => v.available); if (input.checked && input.disabled) form.elements[input.name].value = 'none'; });
      on(form, 'change', () => { completed = false; if (!ambiguous) $('viewCart').hidden = true; updateKit(); });
      on($('pickerKitLink'), 'click', () => {
        const picks = L.problems[selectedProblem].picks, available = key => P[key]?.variants.some(v => v.available);
        form.elements.swim.value = picks.find(key => ['kaia', 'scarlett', 'thea', 'maja'].includes(key) && available(key)) || 'none';
        form.elements.internal.value = selectedProblem === 4 && available('tampon') ? 'tampon' : 'none';
        form.elements.after.value = picks.find(key => ['margaret', 'flexi', 'dry'].includes(key) && available(key)) || 'none';
        completed = false; updateKit();
      });
      const cartRoot = (window.Shopify?.routes?.root || data.root || '/').replace(/\/?$/, '/');
      async function getCart(sections) {
        const response = await fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart refresh');
        const cart = await response.json(); if (sections) cart.sections = sections;
        if (window.FoxTheme?.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        return cart;
      }
      on(form, 'submit', async e => {
        e.preventDefault();
        if (submitting || ambiguous || completed) return;
        const current = selection();
        if (current.errors.length) { $('kitMessage').textContent = L.emptySelection; if (!form.reportValidity()) return; form.querySelector('input:not(:disabled)')?.focus(); return; }
        submitting = true; const button = $('checkoutLink'); button.disabled = true; button.setAttribute('aria-busy', 'true'); button.querySelector('[data-cart-label]').textContent = L.busy;
        form.querySelectorAll('input,select').forEach(input => { input.dataset.nordicDisabled = String(input.disabled); input.disabled = true; });
        let responseData, added = false;
        try {
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
          const response = await fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: current.chosen.map(v => ({ id: v.id, quantity: 1 })), sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname }) });
          responseData = await response.json();
          if (!response.ok || responseData.status) throw new Error('Cart add');
          added = true; completed = true;
          await getCart(responseData.sections);
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: responseData } }));
          const drawer = document.querySelector('cart-drawer');
          if (window.FoxTheme?.settings?.cartType !== 'page' && drawer?.show) drawer.show(button);
          $('kitMessage').textContent = L.added; $('viewCart').hidden = false;
        } catch {
          // A multi-item failure can be partial. Never automatically repeat the add.
          ambiguous = !added; completed = added;
          $('kitMessage').textContent = added ? L.added : L.cartError; $('viewCart').hidden = false;
          try { await getCart(); document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } })); } catch { /* The persistent cart link remains the recovery path. */ }
        } finally {
          submitting = false; button.removeAttribute('aria-busy'); button.disabled = ambiguous || completed;
          button.querySelector('[data-cart-label]').textContent = ambiguous ? L.reviewCart : completed ? L.added : L.checkout;
          form.querySelectorAll('[data-nordic-disabled]').forEach(input => { input.disabled = input.dataset.nordicDisabled === 'true'; delete input.dataset.nordicDisabled; });
        }
      });
      on(form, 'change', () => { if (!submitting && !ambiguous) { $('checkoutLink').disabled = false; $('checkoutLink').querySelector('[data-cart-label]').textContent = L.checkout; } });
      updateKit();
    }

    // Wave rendering runs only while visible, with a 30 fps ceiling and explicit cleanup.
    const waves = $$('canvas[data-wave]').map(canvas => ({ canvas, ctx: canvas.getContext('2d'), visible: false, width: 0, height: 0 }));
    function draw(now, force = false) {
      for (const wave of waves) {
        if ((!wave.visible && !force) || !wave.ctx) continue;
        const { canvas, ctx } = wave, w = canvas.clientWidth, h = canvas.clientHeight, scale = Math.min(devicePixelRatio || 1, 2); if (!w || !h) continue;
        if (wave.width !== w || wave.height !== h) { wave.width = w; wave.height = h; canvas.width = w * scale; canvas.height = h * scale; }
        ctx.setTransform(scale, 0, 0, scale, 0, 0); ctx.clearRect(0, 0, w, h);
        const time = paused ? 0 : now * .00018;
        for (let layer = 0; layer < 2; layer++) { ctx.beginPath(); ctx.moveTo(0, h); for (let x = 0; x <= w + 12; x += 12) ctx.lineTo(x, h * .5 + Math.sin(x / w * Math.PI * 2 + time + layer * .7) * h * .17 + Math.sin(x / w * Math.PI * 4 - time * .6) * h * .07 + layer * 7); ctx.lineTo(w, h); ctx.closePath(); ctx.globalAlpha = layer ? 1 : .35; ctx.fillStyle = canvas.dataset.wave; ctx.fill(); } ctx.globalAlpha = 1;
      }
    }
    let lastFrame = 0;
    animate = now => { frame = 0; if (paused || document.hidden || !waves.some(w => w.visible)) return; if (now - lastFrame > 33) { draw(now); lastFrame = now; } frame = requestAnimationFrame(animate); };
    const waveObserver = new IntersectionObserver(entries => { entries.forEach(e => { const wave = waves.find(w => w.canvas === e.target); if (wave) wave.visible = e.isIntersecting; }); if (!frame && !paused && !document.hidden && waves.some(w => w.visible)) frame = requestAnimationFrame(animate); });
    waves.forEach(w => waveObserver.observe(w.canvas)); observers.push(waveObserver);
    on(window, 'resize', () => { cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(() => draw(performance.now(), true)); });
    draw(performance.now(), true); syncMotion();
    destroyCurrent = () => { lifecycle.abort(); observers.forEach(o => o.disconnect()); cancelAnimationFrame(frame); cancelAnimationFrame(scrollFrame); cancelAnimationFrame(resizeFrame); cleanups.forEach(fn => fn()); };
  }
  window.FemiekoNordic = { init };
  let reloadTimer;
  document.addEventListener('shopify:section:load', () => { clearTimeout(reloadTimer); reloadTimer = setTimeout(init, 30); });
  document.addEventListener('shopify:section:unload', () => { destroyCurrent(); clearTimeout(reloadTimer); reloadTimer = setTimeout(init, 30); });
  window.addEventListener('pagehide', () => destroyCurrent());
  window.addEventListener('pageshow', e => { if (e.persisted) init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
